<template>
  <v-autocomplete
    v-model="valor_computed"
    :items="itens"
    item-value="value"
    item-text="text"
    outlined
    dense
    hide-details
    v-bind="$attrs"
  />
</template>

<script>
export default {
  model: {
    prop: "modelValue",
    event: 'update:modelValue',
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
  },
  data: () => ({
    itens: [
      { value: 'BOBINA', text:	'BOBINAS'},
      { value: 'FIXO', text:	'LANCE FIXO'},
      { value: 'LANCE', text:	'LANCE'},
      { value: 'RL015', text:	'ROLO COM 15 METROS'},
      { value: 'RL020', text:	'ROLO COM 20 METROS'},
      { value: 'RL050', text:	'ROLO COM 50 METROS'},
      { value: 'RL025', text:	'ROLO COM 25 METROS'},
      { value: 'RL030', text:	'ROLO COM 30 METROS'},
      { value: 'RL040', text:	'ROLO COM 40 METROS'},
      { value: 'RL044', text:	'ROLO COM 44 METROS'},
      { value: 'RL060', text:	'ROLO COM 60 METROS'},
      { value: 'RL090', text:	'ROLO COM 90 METROS'},
      { value: 'RL100', text:	'ROLO COM 100 METROS'},
      { value: 'RL150', text:	'ROLO COM 150 METROS'},
      { value: 'RL200', text:	'ROLO COM 200 METROS'},
      { value: 'RL400', text:	'ROLO COM 400 METROS'},
      { value: 'RL300', text:	'ROLO COM 300 METROS'},
      { value: 'RL305', text:	'ROLO COM 305 METROS'},
    ]
  }),
  computed: {
    valor_computed: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>
